const points = "0,70 40,58 80,62 120,44 160,48 200,30 240,36 280,18";
const area = `M0,70 L40,58 L80,62 L120,44 L160,48 L200,30 L240,36 L280,18 L280,90 L0,90 Z`;

export const EngageDashboard = () => (
  <div
    className="flex h-full w-full flex-col overflow-hidden rounded-xl border border-kryvo-green/10 bg-white text-left shadow-[0_24px_60px_-24px_rgba(6,78,42,0.35)]"
    data-testid="engage-dashboard-mockup"
  >
    <div className="flex items-center justify-between border-b border-kryvo-green/10 px-4 py-3">
      <div>
        <p className="font-display text-[13px] font-semibold text-kryvo-ink">Kryvo Engage</p>
        <p className="text-[10px] text-kryvo-ink/50">Campaign Performance</p>
      </div>
      <div className="flex gap-1.5">
        <span className="rounded-full bg-kryvo-green px-2.5 py-1 text-[10px] font-semibold text-white">Email</span>
        <span className="rounded-full bg-kryvo-lime/25 px-2.5 py-1 text-[10px] font-semibold text-kryvo-deep">
          WhatsApp
        </span>
      </div>
    </div>

    <div className="grid grid-cols-3 gap-2 px-4 pt-3">
      {[
        { label: "Opens", tone: "text-kryvo-green" },
        { label: "Clicks", tone: "text-kryvo-green" },
        { label: "Engagement", tone: "text-kryvo-deep" },
      ].map((s) => (
        <div key={s.label} className="rounded-lg border border-kryvo-green/10 bg-kryvo-mist/70 px-2.5 py-2">
          <p className="text-[9px] font-medium uppercase tracking-wider text-kryvo-ink/50">{s.label}</p>
          <p className={`text-[11px] font-semibold ${s.tone}`}>Trending up</p>
        </div>
      ))}
    </div>

    <div className="mx-4 mt-3 rounded-lg border border-kryvo-green/10 p-3">
      <p className="mb-1 text-[10px] font-semibold text-kryvo-ink/70">Engagement over time</p>
      <svg viewBox="0 0 280 90" className="h-20 w-full" preserveAspectRatio="none" aria-hidden="true">
        <path d={area} fill="rgba(126,217,87,0.18)" />
        <polyline
          points={points}
          fill="none"
          stroke="#087A3D"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="280" cy="18" r="3.5" fill="#7ED957" stroke="#064E2A" strokeWidth="1.5" />
      </svg>
    </div>

    <div className="mt-3 flex flex-col gap-1.5 px-4 pb-4">
      {[
        { name: "Welcome journey", channel: "Email", status: "Active" },
        { name: "Festive offer blast", channel: "WhatsApp", status: "Sending" },
      ].map((c) => (
        <div
          key={c.name}
          className="flex items-center justify-between rounded-lg border border-kryvo-green/10 px-3 py-2"
        >
          <div className="min-w-0">
            <p className="truncate text-[11px] font-semibold text-kryvo-ink">{c.name}</p>
            <p className="text-[9px] text-kryvo-ink/50">{c.channel} campaign</p>
          </div>
          <span className="rounded-full bg-kryvo-mist px-2 py-0.5 text-[9px] font-semibold text-kryvo-green">
            {c.status}
          </span>
        </div>
      ))}
    </div>
  </div>
);

export default EngageDashboard;
